import * as Sentry from "@sentry/react"

const dsn = document
  .querySelector<HTMLMetaElement>('meta[name="sentry-dsn"]')
  ?.content?.trim()

if (dsn) {
  Sentry.init({
    dsn,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    tracePropagationTargets: [/^\//],
  })
}
